import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { uniqueGroupByName } from '../helpers';
import { pathCompany } from '../requests';
import type { PathCompanyRequestType } from '../types';

export const usePathCompany = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [API_QUERY_KEYS.postCompany],
    mutationFn: (bodyParams: PathCompanyRequestType['bodyParams']) =>
      pathCompany({
        bodyParams,
      }),
    onSuccess: async data => {
      await queryClient.invalidateQueries({
        queryKey: [API_QUERY_KEYS.companyGroups],
      });
      queryClient.setQueryData(
        [API_QUERY_KEYS.companyGroups],
        (oldData: any = []) => {
          const addedGroups = data?.groups || [];
          return uniqueGroupByName([...oldData, ...addedGroups]);
        },
      );
    },
  });
};
